import { useNavigate } from 'react-router-dom';
import Breadcrumb from '@/components/common/Breadcrumb';
import CSVUpload from '@/components/common/CSVUpload';
import { useToast } from '@/components/common/Toast';
import { ParsedCSVData } from '@/types/upload';
import { validateCornerCsv } from '@/utils/cornerCsvValidation';

const CornerUpload = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleUploadSuccess = (_data: ParsedCSVData) => {
    showToast('アップロードを受け付けました。処理状況はアップロード一覧で確認してください');
    navigate('/upload-management/new');
  };

  return (
    <div>
      <Breadcrumb />
      <div className="card max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-admin-text mb-2">トップページ（コーナー）CSVアップロード</h1>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h2 className="font-semibold text-admin-text mb-2">📋 CSVファイルのフォーマットと注意事項</h2>
          <ul className="text-sm text-admin-textLight space-y-1 list-disc list-inside">
            <li>ファイル形式：CSV形式（.csv）のみ / サイズ 10MB 以下 / 文字コード UTF-8（BOM 可）</li>
            <li>Book / Product と同じ 3 行構成：1 行目＝定義名 / 2 行目＝日本語表示名 / 3 行目以降＝データ</li>
            <li>1 ファイル = 1 コーナー。PAGE 行は 3 行目に 1 行のみ（コーナーメタ）</li>
            <li>
              列：data_type, corner_name, slug, block_id, start_at, stop_at, title, block_type,
              generate_type, block_link_to, block_link_target, block_link_txt, item_type, item,
              item_link_to, item_link_target, platform, note
            </li>
            <li>data_type は PAGE / BLOCK / ITEM（行順がそのまま表示順。ITEM は直前 BLOCK 配下）</li>
            <li>slug / block_id は a-z / 0-9 / _ / - のみ</li>
            <li>generate_type は auto / manual。auto の block_id は new_comic / new_magazine のみ</li>
            <li>generate_type=auto のブロック直後に ITEM 行は置けません（サーバが自動生成）</li>
            <li>platform は 3 桁（web/ios/android, 1=表示/0=非表示。000 は不可。BLOCK 必須・ITEM 任意）</li>
          </ul>
        </div>

        <CSVUpload
          uploadType="Corner"
          customValidate={validateCornerCsv}
          onUploadSuccess={handleUploadSuccess}
        />

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => navigate('/upload-management/new')}
            className="px-6 py-2 border border-gray-300 text-admin-text rounded-lg hover:bg-gray-50 transition-colors"
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default CornerUpload;
